import { render, staticRenderFns } from "./anchorInfo.vue?vue&type=template&id=243171bf&scoped=true&"
import script from "./anchorInfo.vue?vue&type=script&lang=js&"
export * from "./anchorInfo.vue?vue&type=script&lang=js&"
import style0 from "./anchorInfo.vue?vue&type=style&index=0&id=243171bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243171bf",
  null
  
)

export default component.exports